<template>
  <video class="video" @loadedmetadata="videoLoaded" @emptied="videoEmptied" @error="videoError" @ended="videoEnded"
    @play="videoPlay" @pause="videoPause" :id="id" :src="src" controls autoplay muted :disable-picture-in-picture="true" :controlslist="'nodownload'" oncontextmenu="return false"></video>
</template>
<script>
export default {
  components: {},
  props: {
    src: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "video",
    },
    showControls: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  created() {
    this.$nextTick(() => {
      this.removepip();
    });
  },
  methods: {
    removepip() {
      const video = document.getElementById(this.id);
      video['disablePictureInPicture'] = true;
    },
    videoLoaded(e) {
    },
    videoPlay() {
      this.$emit("videoStatusChange", 1);
    },
    videoPause() {
      // 暂停
      this.$emit("videoStatusChange", 2);
    },
    videoEmptied() {
      // 视频播放中断
      this.$emit("videoStatusChange", 2);
    },
    videoError(e) {
      // 播放出错
      this.$emit("videoStatusChange", 2);
    },
    videoEnded() {
      // 播放结束
      this.$emit("videoStatusChange", 3);
    }
  },
};
</script>
<style lang='scss' scoped>
.video {
  width: 100%;
  height: 100%;

}


</style>